import { RootState } from "redux-store";

export const getDevicesInfo = (state: RootState) => state?.stats?.devicesInfo;
export const getDevicesPerDayList = (state: RootState) =>
  state?.stats?.devicesPerDayList;
export const getSubscribedAndReachedPerEventList = (state: RootState) =>
  state?.stats?.subscribedAndReachedPerEventList;
export const getStatsFilters = (state: RootState) =>
  state?.stats?.filters ?? {};
export const getStatsDateFilterType = (state: RootState) =>
  state?.stats?.dateFilterType;
